/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportConfigurationForAssessmentRun extends models.ReportConfiguration {
    constructor() {
        super();
        this.setDiscriminator("ReportConfigurationForAssessmentRun");
    }

    getFixupPrototypeFunction() { return ReportConfigurationForAssessmentRun.fixupPrototype; }

    static newInstance(model: Partial<ReportConfigurationForAssessmentRun>): ReportConfigurationForAssessmentRun {
        let obj = Object.assign(new ReportConfigurationForAssessmentRun(), model);
        ReportConfigurationForAssessmentRun.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportConfigurationForAssessmentRun>): ReportConfigurationForAssessmentRun {
        if (!model) return null;
        return ReportConfigurationForAssessmentRun.newInstance(<ReportConfigurationForAssessmentRun> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportConfigurationForAssessmentRun) {
        if (!obj) return;

        models.ReportConfigurationForAssessmentRun.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportConfigurationForAssessmentRun): boolean {
        if (models.ReportConfiguration.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ReportConfigurationForAssessmentRun.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.assessment_run) {
            models.RecordIdentity.fixupPrototype(this.assessment_run);
        }
        if (this.filter_model) {
            models.QueryOperator.fixupPrototype(this.filter_model);
        }
    }

    /**
     * The Assessment Run this report is for
     */
    assessment_run: models.RecordIdentity;

    /**
     * Identity of the Framework
     */
    framework_id: string;

    filter_model: models.QueryOperator;

}
